import React from "react";
// import App from 'next/app'
import { CookiesProvider } from 'react-cookie';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import QuamRouter from './router'
import '../scss/app.css'
import '../scss/tailwind.css'
import '../scss/print.scss'

// styled-components v6 removed automatic prop filtering for DOM elements.
// This codebase uses many styling props (e.g. `inline`, `align`, `padding`,
// `bgColor`, `currDevice`, etc.) directly on styled.div / styled.a / etc.
// without the transient `$` prefix. Restoring v5 behavior centrally here
// avoids a sweeping rename across 75+ files / 158 .attrs() calls.
//
// We only filter at the DOM boundary: when the rendered target is a string
// (e.g. 'div', 'a'), apply isPropValid; when it's a component, forward
// everything so nested styled components can still receive style props.
const shouldForwardProp = (prop, target) =>
  typeof target === 'string' ? isPropValid(prop) : true;

function QuamApp() {

  return (<StyleSheetManager shouldForwardProp={shouldForwardProp}>
    <CookiesProvider>
      <QuamRouter />
    </CookiesProvider>
  </StyleSheetManager>);
}

export default QuamApp;
